function deserializeMapFromObject<V>(
    obj: Record<string, V>
): Map<string, V>;
function deserializeMapFromObject<K, V>(
    obj: Record<string, V>,
    keyProcessor: (key: string) => K | undefined
): Map<K, V>;

function deserializeMapFromObject<K, V>(
    obj: Record<string, V>,
    keyProcessor?: (key: string) => K | undefined
): Map<K | string, V> {
    const result = new Map();

    Object.entries(obj).forEach(([key, value]) => {
        const k = keyProcessor ? keyProcessor(key) : key;

        if (k === undefined) return;

        result.set(k, value);
    }, [])

    return result;
}

export {
    deserializeMapFromObject,
}
